import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { withRouter } from 'react-router';
import { Helmet } from 'react-helmet';

import { jsx, css } from '@emotion/core';
import Button from '../../shared/Button/Button';
import TextField from '../../shared/FormFields/TextField';

import { passwordReset } from '../../../redux/modules/user';

import './RecuperoPassword.scss';

class RecuperoPassword extends Component {
  requestReset = ({ email }) => {
    this.props.passwordReset(email);
  };

  render() {
    const { error, passwordResetRequested } = this.props.user;
    const { primaryColor, siteName, siteUrl } = this.props;

    const recuperoPasswordStyle = css`
      .form-control {
        &:focus {
          border-color: ${primaryColor}!important;
        }
      }
    `;

    return (
      <div className="recupero-password">
        <Helmet
          title={'Recupero Password'}
          meta={[
            {
              name: 'description',
              content: `${siteName} - Ecommerce Farmacia vendita - Recupero Password`,
            },
            {
              name: 'keywords',
              content: `Recupero Password, ecommerce, farmacia, ${siteName}`,
            },
            {
              name: 'robots',
              content: 'index, follow',
            },
          ]}
          link={[
            {
              rel: 'canonical',
              href: `${siteUrl}/recupero-password`,
            },
          ]}
        />
        <div className="container">
          <h1>Recupero Password</h1>

          {!passwordResetRequested && (
            <div>
              <h2 className="subtitle">
                Inserisci la tua email per ricevere il link per resettare la tua
                password.
              </h2>

              <form
                onSubmit={this.props.handleSubmit(this.requestReset)}
                css={recuperoPasswordStyle}
              >
                <Field
                  name="email"
                  component={TextField}
                  type="email"
                  label="Inserisci la tua email"
                />
                <div className="btn-container">
                  <Button type="submit" className="btn btn-primary">
                    Richiedi reset password
                  </Button>
                </div>
              </form>
            </div>
          )}

          {!!passwordResetRequested && (
            <div className="alert alert-success">
              <p>La tua richiesta è stata inviata correttamente!</p>
              <p>
                Fra poco riceverai la nostra email di conferma. Clicca sul link
                per resettare la tua password.
              </p>
            </div>
          )}

          {!passwordResetRequested && error.length > 0 && (
            <div className="alert alert-danger">
              <p>
                È avvenuto un errore durante la richiesta di reset della tua
                password.
              </p>
              <p>Controlla che l'email che hai inserito sia corretta.</p>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const validate = values => {
  const errors = {};

  if (!values.email) {
    errors.email = 'Richiesto';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Indirizzo email non valido';
  }

  return errors;
};

RecuperoPassword = reduxForm({
  form: 'password-reset-request',
  validate,
})(RecuperoPassword);

const mapStateToProps = state => {
  return {
    user: state.user,
    primaryColor: state.store.data.loghiTemplate.brandColor,
    siteName: state.store.data.datiFarmacia.siteName,
    siteUrl: state.store.data.datiFarmacia.siteUrl,
  };
};

export default withRouter(
  connect(mapStateToProps, { passwordReset })(RecuperoPassword)
);
